import React from 'react';
import LibraryPage from '../components/library/LibraryPage';

/** The school's policies, for staff to read and download. */
const PolicyPage: React.FC = () => (
  <LibraryPage config={{
    kind: 'policies',
    module: 'policies',
    title: 'Policies',
    subtitle: 'The rules the school runs by — for staff to read and download.',
    noun: 'policy',
    plural: 'policies',
  }} />
);

export default PolicyPage;
